import React from "react";
import { FAQ } from "@app/components/common";
import { ContentComponent } from "../enums";
import {
  Hero,
  AccordionList,
  AdvantagesList,
  IconList,
  Cards,
  SimplifiedHero,
  SimpleText,
  SimpleImage,
  SideImage,
  DoubleImage,
  Benefits,
  DownloadApp,
  DownloadFile,
  Mandates,
  MultitextImage,
  NeighbourImage,
  Reviews,
  SimpleTwoColumnsLists,
  Table,
  TwoColumnsList,
  CurrencyConverter,
  CurrencyConverterChart,
  ImageCarousel,
  ContestContact,
  PerformanceGraphs,
  Ambassadors,
  SwitchCurrencies,
  SimpleContact,
  IconCardsList,
  CheckmarkIconsList,
  SideImageSlides,
  FaqLibrary,
  CardsCarousel,
  Plans,
  ColumnsText,
  TabSlideSwitcher,
  ImageTitle,
  ImageReviews,
  IconBoxes,
  ExtendedContact,
  AffiliateProgramContact,
  BenefitCards,
} from "../components";

export const COMPONENTS_MAP: Record<ContentComponent, React.FC> = {
  [ContentComponent.HERO]: Hero,
  [ContentComponent.ACCORDION_LIST]: AccordionList,
  [ContentComponent.ADVANTAGES_LIST]: AdvantagesList,
  [ContentComponent.CHECKMARK_LIST]: CheckmarkIconsList,
  [ContentComponent.ICON_LIST]: IconList,
  [ContentComponent.CARDS]: Cards,
  [ContentComponent.SIMPLIFIED_HERO]: SimplifiedHero,
  [ContentComponent.SIMPLE_TEXT]: SimpleText,
  [ContentComponent.SIMPLE_IMAGE]: SimpleImage,
  [ContentComponent.SIDE_IMAGE]: SideImage,
  [ContentComponent.DOUBLE_IMAGE]: DoubleImage,
  [ContentComponent.BENEFITS]: Benefits,
  [ContentComponent.DOWNLOAD_APP]: DownloadApp,
  [ContentComponent.DOWNLOAD_FILE]: DownloadFile,
  [ContentComponent.FAQ]: FAQ,
  [ContentComponent.MANDATES]: Mandates,
  [ContentComponent.MULTITEXT_IMAGE]: MultitextImage,
  [ContentComponent.NEIGHBOUR_IMAGE]: NeighbourImage,
  [ContentComponent.REVIEWS]: Reviews,
  [ContentComponent.SIMPLE_TWO_COLUMNS_LISTS]: SimpleTwoColumnsLists,
  [ContentComponent.TABLE]: Table,
  [ContentComponent.TWO_COLUMNS_LIST]: TwoColumnsList,
  [ContentComponent.CURRENCY_CONVERTER]: CurrencyConverter,
  [ContentComponent.CURRENCY_CONVERTER_CHART]: CurrencyConverterChart,
  [ContentComponent.IMAGE_CAROUSEL]: ImageCarousel,
  [ContentComponent.CONTEST_CONTACT]: ContestContact,
  [ContentComponent.PERFORMANCE_GRAPHS]: PerformanceGraphs,
  [ContentComponent.AMBASSADORS]: Ambassadors,
  [ContentComponent.SWITCH_CURRENCIES]: SwitchCurrencies,
  [ContentComponent.SIMPLE_CONTACT]: SimpleContact,
  [ContentComponent.ICON_CARDS_LIST]: IconCardsList,
  [ContentComponent.SIDE_IMAGE_SLIDES]: SideImageSlides,
  [ContentComponent.FAQ_LIBRARY]: FaqLibrary,
  [ContentComponent.CARDS_CAROUSEL]: CardsCarousel,
  [ContentComponent.PLANS]: Plans,
  [ContentComponent.COLUMNS_TEXT]: ColumnsText,
  [ContentComponent.TAB_SLIDE_SWITCHER]: TabSlideSwitcher,
  [ContentComponent.IMAGE_TITLE]: ImageTitle,
  [ContentComponent.IMAGE_REVIEWS]: ImageReviews,
  [ContentComponent.ICON_BOXES]: IconBoxes,
  [ContentComponent.EXTENDED_CONTACT]: ExtendedContact,
  [ContentComponent.AFFILIATE_PROGRAM]: AffiliateProgramContact,
  [ContentComponent.BENEFIT_CARDS]: BenefitCards,
};
